import { queryOptions } from '@tanstack/react-query'

import type { PlatformUserListResponse } from '@/bindings/PlatformUserListResponse'
import type { PlatformUserSummary } from '@/bindings/PlatformUserSummary'
import { request } from '@/lib/api'
import { PAGE_SIZE } from '@/lib/paging'

/** `all` prefixes every platform-user query, so one invalidation refreshes list and detail. */
export const platformUserKeys = {
  all: ['platform', 'users'] as const,
  list: (page: number) => ['platform', 'users', 'list', page] as const,
  detail: (id: string) => ['platform', 'users', 'detail', id] as const,
}

export function platformUserPath(id: string) {
  return `/platform/users/${id}`
}

export function platformUserListQuery(page: number) {
  return queryOptions({
    queryKey: platformUserKeys.list(page),
    queryFn: () => request<PlatformUserListResponse>(`/platform/users?page=${page}&per_page=${PAGE_SIZE}`),
  })
}

export function platformUserDetailQuery(id: string) {
  return queryOptions({
    queryKey: platformUserKeys.detail(id),
    queryFn: () => request<PlatformUserSummary>(platformUserPath(id)),
  })
}

export function platformUserName(user: Pick<PlatformUserSummary, 'first_name' | 'last_name' | 'email'>): string {
  return [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email
}
